import { render, staticRenderFns } from "./coTagList.vue?vue&type=template&id=deb5047a&scoped=true&"
import script from "./coTagList.vue?vue&type=script&lang=ts&"
export * from "./coTagList.vue?vue&type=script&lang=ts&"
import style0 from "./coTagList.vue?vue&type=style&index=0&id=deb5047a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb5047a",
  null
  
)

export default component.exports